import {Component, ViewChild} from '@angular/core';
import {NavController, NavParams, ViewController} from "ionic-angular";
import {Api} from "../../providers/api";
import {CartManager} from "../../providers/cart-manager";
import {ShipmentcartManagerProvider} from "../../providers/shipmentcart-manager";
import {GVLogger} from "../../services/gv-logger";
import moment from "moment";

@Component({
  selector: 'page-move-product-location-model',
  templateUrl: 'move-product-location-model.html',
})
export class MoveProductLocationModelPage {

  title = "";
  message= "";
  AvailableQuantity = 100;
  orderStatus: any;
  productQuantity: any;
  private totalQuantity = 0;
  private totalQuantityToBeMoved = 0;
  // private data: any;
  private itemRemainingCount = 0;
  private negationCheck = true;
  private totalItemCount = 0;
  private getItems: any;
  private product: any;
  private qtyBeforeAddBarCode = [];

  // @ViewChild('locationInput') locationInput;


  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private viewCtrl:ViewController,
              private api:Api,
              private cartManager:CartManager,
              private shipmentCartManager: ShipmentcartManagerProvider,
              private gVLogger: GVLogger) {

    this.gVLogger.log(this.navParams);
    this.product = JSON.parse(this.navParams.get('product'));
    // this.data = this.navParams.get('data');
    // this.product = JSON.parse(this.product);
    this.gVLogger.log("the product from pick pack location page : " + JSON.stringify(this.product));
    for(let location of this.product.productInventoryLocationsDTO){
      this.totalQuantity += location.quantityRemaining;
    }
    // this.totalQuantity = this.product.quantity;
    this.itemRemainingCount = this.totalQuantity;
    this.totalQuantityToBeMoved = this.totalQuantity;
    this.gVLogger.log(this.totalQuantity + " is the total quantity");
    this.orderStatus = this.navParams.get('orderStatus');



    for (let item of this.product.productInventoryLocationsDTO) {
      // this.itemRemainingCount -= item.quantityRemaining;
      // if(this.itemRemainingCount >= 0){
      //   item.quantityReceived = item.quantityRemaining;
      //   this.totalItemCount +=  item.quantityRemaining;
      //   if(this.itemRemainingCount === 0){
      //     this.negationCheck = false;
      //   }
      // }
      // else {
      //   if(this.negationCheck){
      //     item.quantityReceived = this.itemRemainingCount + item.quantityRemaining;
      //     this.negationCheck = false;
      //   }
      //   else {
      //     item.quantityReceived = 0;
      //   }
      // }
      this.gVLogger.log("item.status in constructor : " + JSON.stringify(item));
      if (item.quantityReceived <=0 && item.status === 0) {
        item.status = 1;
        item.quantityReceived = item.quantityRemaining;
      }
      this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
    }
    // this.getLocationsAndQuantityAgainstProduct(this.product);
  }


  ngAfterViewChecked() {

  }

  // ionViewDidEnter() {
  //   this.locationInput.setFocus();
  // }
  //
  // ngOnInit(){
  //   this.locationInput.setFocus();
  // }
  //
  // ionViewWillEnter(){
  //   this.locationInput.setFocus();
  // }


  getOrderStatus(){
    // this.gVLogger.log("oooooorrrrrrdddddeeeeeerrrrrSSStatusdsds", this.orderStatus);
    if(this.orderStatus == 2 || this.orderStatus == 5){
      return true;
    }
    else{
      return false;
    }
  }

  convertStringToDate(stringDate){
    // return new Date(stringDate).getMonth() + "/" + new Date(stringDate).getDate() + "/" + new Date(stringDate).getFullYear();
    return moment.utc(stringDate).format("MM/DD/YYYY");
  }

  ionViewDidLoad() {

    // setTimeout(() => {
    //
    //   this.locationInput.setFocus();
    //
    // },800);
  }

  close(){
    this.viewCtrl.dismiss(this.product.productInventoryLocationsDTO);
  }

  updateInventoryOnLocations(){
    let quantity = 0;
    for(let item of this.product.productInventoryLocationsDTO){
      this.gVLogger.log("total quantity received while updating" + item.quantityReceived);
      quantity += Number(item.quantityReceived);
    }
    this.gVLogger.log("");
    let prod = this.product;
    // prod.quantity = quantity;
    this.viewCtrl.dismiss(prod.productInventoryLocationsDTO);
    // this.shipmentCartManager.addProductToCart(prod);
    this.gVLogger.log("quantity while dismissing prod in product location model : " + JSON.stringify(prod));
    this.gVLogger.log("quantity while dismissing product : " + JSON.stringify(this.product));

  }

  totalquantityPicked(){
    let quantity = 0;
    for(let item of this.product.productInventoryLocationsDTO){
      quantity += Number(item.quantityReceived);
    }
    // this.gVLogger.log("total quantity Picked : " + quantity);
    return Number(quantity) ;
  }

  totalquantityRemaining(){
    let quantity = 0;
    for(let item of this.product.productInventoryLocationsDTO){
      quantity += Number(item.quantityReceived);
    }
    // this.gVLogger.log("total quantity Picked : " + quantity);
    return Number(this.totalQuantityToBeMoved) - Number(quantity);
  }

  // imageNotFound(){
  //   this.product.productImagesDTO[0].name = "nan";
  //   this.product.productImagesDTO[0].extension = "png";
  // }
  imageNotFound(e,item){
    item.productImagesDTO[0].extension = "png";
    item.productImagesDTO[0].name = "dummy";
  }

  makeImageURL(dimensions, item){
    this.gVLogger.log("---------makeImageurl-------lllllll--" + JSON.stringify(item));
    if(this.product.productImagesDTO[0].name === "dummy" || this.product.productImagesDTO[0].name === "dummy"){
      // this.gVLogger.log("---------dummy if---------");
      // if(this.constants.isWebstore){
      return this.cartManager.makeNANImageURLFromImage(dimensions);
      // }
      // else{
      //   return "./assets/img/nan-"+dimensions+".png";
      // }
    }else{
      return this.cartManager.makeImageURL(dimensions,this.product);
    }
  }

  getProductsInCart(event){
    this.getItems = event.target.value;
    this.gVLogger.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee" + event.target.value);
  }

  // getLocationsAndQuantityAgainstProduct(product){
  //   this.api.get("inventory/stockOnLocationsAgaistProduct/"+product).map(res => res.json()).subscribe(data => {
  //     this.gVLogger.log("data form stockOnLocationsAgaistProduct : " + data);
  //   });
  // }

  removeProductFromCart(product){
    this.gVLogger.log("poductquantityRemaining" + product.quantityRemaining);
    this.gVLogger.log("poductquantityReceived" + product.quantityReceived);
    if(product.quantityReceived > 0){
      product.quantityReceived--;
      this.totalItemCount--;
      product.status = 1;
      this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
      // this.shipmentCartManager.removeOneNew(product);
    }
  }

  updateProductInCart(product){
    if(String(product.quantityReceived) !="" && String(product.quantityReceived).match(/^\d+$/)){

      if(Number(this.getItems) === Number(product.quantityReceived)){

        product.quantityReceived = Number(this.getItems);
        this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
        return;
      }
      this.totalItemCount -= Number(this.getItems);

      if(Number(this.totalItemCount) < Number(this.totalQuantity)){
        let difference = Number(this.totalQuantity) - Number(this.totalItemCount);
        this.gVLogger.log("difference " + difference);
        if(Number(product.quantityReceived) <= Number(difference)){
          if(Number(product.quantityReceived) <= Number(product.quantityRemaining)){
            product.quantityReceived = Number(product.quantityReceived);
            this.totalItemCount += Number(product.quantityReceived);
            this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
            product.status = 1;
          }
          else {
            product.quantityReceived = Number(product.quantityRemaining);
            this.totalItemCount += Number(product.quantityRemaining);
            this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
            product.status = 1;
          }
        }
        else {
          if(Number(product.quantityRemaining) <= Number(difference)){
            product.quantityReceived = Number(product.quantityRemaining);
            this.totalItemCount += Number(product.quantityRemaining);
            this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
            product.status = 1;
          }
          else {
            product.quantityReceived = Number(difference);
            this.totalItemCount += Number(difference);
            this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
            product.status = 1;
          }
        }
      }
      else {
        product.quantityReceived = 0;
        this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
      }

    }else{

      this.totalItemCount -= Number(this.getItems);
      let difference = Number(this.totalItemCount) - Number(this.totalQuantity);
      if(Number(difference) <= Number(product.quantityRemaining)){
        product.quantityReceived = Number(difference);
        this.totalItemCount += Number(difference);
        this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
        product.status = 1;
      }
      else {
        product.quantityReceived = Number(product.quantityRemaining);
        this.totalItemCount += Number(product.quantityRemaining);
        this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
        product.status = 1;
      }

    }
    this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
  }

  addProductToCart(product){
    if(this.totalItemCount < this.totalQuantity){
      if(Number(product.quantityReceived) < Number(product.quantityRemaining)){
        product.quantityReceived++;
        this.totalItemCount++;
        product.status = 1;
        this.gVLogger.log("product ststus" + product.status);
        this.qtyBeforeAddBarCode = this.product.productInventoryLocationsDTO;
      }
    }
  }

  addFromBarCode(event) {
    event.target.value = event.target.value.trim();
    const value = event.target.value;
    if(value && value.trim() != ""){
      this.product.productInventoryLocationsDTO = this.product.productInventoryLocationsDTO.filter((item) => {
        return (item.inventoryLocationById.locationCode.toLowerCase().indexOf(value.toLowerCase()) > -1);
      })
    }
    else {
      this.product.productInventoryLocationsDTO = this.qtyBeforeAddBarCode;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/move-product-location-model/move-product-location-model.ts